import React, { useMemo, useState } from "react";
import styles from "./index.module.scss";
import Viewer from "react-viewer";
import useModalHandler from "utils/useModalHandler";

interface StuPhotosProps {
    data: string[];
}

export default function StuPhotos({ data }: StuPhotosProps) {
    const modal = useModalHandler();
    const [active, setActive] = useState(0);

    function onView(index: number) {
        setActive(index);
        modal.open();
    }

    //预览图片
    const viewerSrc = useMemo(() => {
        return data.map(item => ({ src: item, alt: "" }));
    }, [data]);

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>学生上传作答内容</h1>

            <div className={styles.list}>
                {data.map((url, index) => (
                    <img
                        key={index}
                        src={url}
                        alt=""
                        onClick={() => onView(index)}
                    />
                ))}
            </div>

            <Viewer
                visible={modal.visible}
                activeIndex={active}
                images={viewerSrc}
                onClose={modal.close}
                onMaskClick={modal.close}
            />
        </div>
    );
}
